import React from 'react';
import { wrapDisplayName } from 'recompose';
import _ from 'lodash';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import {
  getResult,
  createCancelToken,
  mapState,
} from '@deerplusofficial/pos-helper';
import { withClient } from '@deerplusofficial/pos-hoc';
import actions from '../../actions';

const {
  enable,
  list: { update },
} = actions.preOrder;

export default config => Component =>
  fp.compose(
    withClient(),
    connect(
      mapState(['preOrder']),
      { update, enable }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryPreOrders');

      componentWillUnmount() {
        !_.isUndefined(this.cancelQueryChannel) && this.cancelQueryChannel();
        !_.isUndefined(this.cancelQueryPreOrders) &&
          this.cancelQueryPreOrders();
      }

      onFetch = async () => {
        const {
          update,
          enable,
          preOrder: { isEnabled },
          client: { POSApi, channelId, onError },
        } = this.props;

        if (!isEnabled) {
          try {
            const {
              channel: { enable_pre_order },
            } = getResult(
              await POSApi.get(`/channels/${channelId}`, {
                cancelToken: createCancelToken(this.cancelQueryChannel),
              })
            );

            if (!enable_pre_order) return;

            enable();
          } catch (error) {
            onError(error);
          }
        }

        try {
          const { pre_orders } = getResult(
            await POSApi.get('/pre_orders', {
              params: { channel_id: channelId, offset: 0, limit: 100 },
              cancelToken: createCancelToken(this.cancelQueryPreOrders),
            })
          );
          update(pre_orders);
        } catch (error) {
          onError(error);
        }
      };

      render() {
        return <Component {...this.props} fetchPreOrders={this.onFetch} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryPreOrders.js